import { File } from '@lmc/ts-common'
import * as types from '../common/types'

export const addForm = ({
  data,
  fields,
  initial,
  formId,
}: {
  data?: object
  fields?: object[]
  initial?: object
  formId: string
}) => ({
  type: types.ADD_FORM,
  data,
  fields,
  initial,
  formId,
})

export const addFormFile = ({
  key,
  file,
  uri,
  formId,
}: {
  key: string
  file: File
  uri: string
  formId: string
}) => ({
  type: types.ADD_FORM_FILE,
  key,
  file,
  uri,
  formId,
})

export const clearFieldValidation = ({
  keys,
  formId,
}: {
  keys: string[]
  formId: string
}) => ({
  type: types.CLEAR_FIELD_VALIDATION,
  keys,
  formId,
})

export const clearForm = (formId: string) => ({
  type: types.CLEAR_FORM,
  formId,
})

export const clearFormArrayField = ({
  key,
  indexes,
  formId,
}: {
  key: string
  indexes: string[]
  formId: string
}) => ({
  type: types.CLEAR_FORM_ARRAY_FIELD,
  key,
  indexes,
  formId,
})

export const clearFormFields = ({
  fields,
  formId,
}: {
  fields?: object[] | string[]
  formId: string
}) => ({
  type: types.CLEAR_FORM_FIELDS,
  fields,
  formId,
})

export const removeForm = (formId: string) => ({
  type: types.REMOVE_FORM,
  formId,
})

export const setFieldValidation = ({
  key,
  label,
  dependsOn,
  relatedKeys,
  required,
  validationTypes,
  formId,
}: {
  key: string
  label: string
  dependsOn: { key: string; value: boolean }
  relatedKeys: string[]
  required: boolean
  validationTypes: string
  formId: string
}) => ({
  type: types.SET_FIELD_VALIDATION,
  key,
  label,
  dependsOn,
  required,
  relatedKeys,
  validationTypes,
  formId,
})

export const setFormField = ({
  key,
  value,
  index,
  formId,
}: {
  key: string
  value: string
  index?: number
  formId: string
}) => ({
  type: types.SET_FORM_FIELD,
  key,
  value,
  index,
  formId,
})

export const setFormState = ({
  key,
  value,
  formId,
}: {
  key: string
  value: object
  formId: string
}) => ({
  type: types.SET_FORM_STATE,
  key,
  value,
  formId,
})

export const setInitialFormFields = ({
  data,
  formId,
}: {
  data: object
  formId: string
}) => ({
  type: types.SET_INITIAL_FORM_FIELDS,
  data,
  formId,
})

export const setValidationErrors = ({
  errors = {},
  formId,
}: {
  errors: object
  formId: string
}) => ({
  type: types.UPDATE_FORM_VALIDATION_ERRORS,
  errors,
  formId,
})

export const toggleFormSubmitting = (formId: string) => ({
  type: types.TOGGLE_FORM_SUBMITTING,
  formId,
})

export const updateFormErrors = ({
  errors = [],
  formId,
}: {
  errors: object[]
  formId: string
}) => ({
  type: types.UPDATE_FORM_ERRORS,
  errors,
  formId,
})
